import AbnormalCause from "@/components/AbnormalCause";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { observer } from "mobx-react-lite";
import React from "react";

interface AbnormalCauseWrapProps {
    order: OrderDTO;
    tab: OrderTab;
}

export function shouldRenderAbnormalCause(order: OrderDTO) {
    return !!order.abnormalCause;
}

const AbnormalCauseWrap: React.FC<AbnormalCauseWrapProps> = function (props) {
    const { order, tab } = props;

    const orderManagementStore = useOrderManagementStore();

    function handleDeleteSuccess(shopId: number) {
        orderManagementStore?.fetchOrders(shopId);

        orderManagementStore?.getOrderListCount();
    }

    return <AbnormalCause order={order} onDeleteSuccess={handleDeleteSuccess} tab={tab} />;
};

export default observer(AbnormalCauseWrap);
